import { render } from "./visita_datos.vue?vue&type=template&id=6ac2a2dc"
import script from "./visita_datos.vue?vue&type=script&lang=js"
export * from "./visita_datos.vue?vue&type=script&lang=js"

import "./visita_datos.vue?vue&type=style&index=0&id=6ac2a2dc&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__